import styled from "styled-components";
import { WrapperContainer } from "../../components";
import { colors } from "../../consts";
import { InputStyles } from "../Input/styled";

export const DropdownInputWrapper = styled(WrapperContainer)`
  input {
    pointer-events: ${(props) => (props?.withoutPointerEvents ? "none" : "all")};
    ${(props) => props?.isActive && `outline: 1px solid ${colors.RAISIN_100}`}
  }

  > div {
    width: 100%;
    cursor: ${(props) => (props?.disabled ? "default" : "pointer")};
    pointer-events: ${(props) => (props?.disabled ? "none" : "all")};

    ${(props) =>
      props.optionsListWidth &&
      `
        &:nth-child(2) {
      width: ${props.optionsListWidth};
    }
    `}
  }
`;

export const ComponentWrapper = styled(WrapperContainer)`
  ${InputStyles}
  padding-top: 7px;
  padding-bottom: 7px;

  min-height: 48px;
  height: fit-content;
`;
